"use strict";

var _slicedToArray = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var _classCallCheck = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createClass.js").default;
var _assertThisInitialized = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/assertThisInitialized.js").default;
var _inherits = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createSuper.js").default;
var _objectSpread = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CSSNativeParseRun = void 0;
var _CSSParseRun = require("./CSSParseRun");
var _helpers = require("./helpers");
var _ShortMergeRequest = require("./ShortMergeRequest");
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var nativeDirectionalStyleKeys = {
  borderBottomEndRadius: 'block',
  borderBottomStartRadius: 'block',
  borderEndColor: 'block',
  borderEndWidth: 'block',
  borderStartColor: 'block',
  borderStartWidth: 'block',
  borderTopEndRadius: 'block',
  borderTopStartRadius: 'block',
  end: 'block',
  marginEnd: 'block',
  marginStart: 'block',
  paddingEnd: 'block',
  paddingStart: 'block',
  start: 'block'
};
var extraLongViewStyles = {
  elevation: 'block',
  overflow: 'block',
  overlayColor: 'block',
  resizeMode: 'block',
  rotation: 'block',
  scaleX: 'block',
  scaleY: 'block',
  shadowColor: 'block',
  shadowOffset: 'block',
  shadowOpacity: 'block',
  shadowRadius: 'block',
  testID: 'block',
  tintColor: 'block',
  transformMatrix: 'block',
  translateX: 'block',
  translateY: 'block'
};
var extraTextStyles = {
  includeFontPadding: 'text',
  textAlignVertical: 'text',
  textShadowColor: 'text',
  textShadowOffset: 'text',
  textShadowRadius: 'text',
  writingDirection: 'text'
};
var extraStylesRegistry = _objectSpread(_objectSpread({}, extraTextStyles), extraLongViewStyles);
var CSSNativeParseRun = /*#__PURE__*/function (_CSSParseRun$CSSParse) {
  _inherits(CSSNativeParseRun, _CSSParseRun$CSSParse);
  var _super = _createSuper(CSSNativeParseRun);
  function CSSNativeParseRun(declaration, registry) {
    var _this;
    _classCallCheck(this, CSSNativeParseRun);
    _this = _super.call(this, registry);
    _defineProperty(_assertThisInitialized(_this), "declaration", void 0);
    _this.declaration = declaration;
    return _this;
  }
  _createClass(CSSNativeParseRun, [{
    key: "fillProp",
    value: function fillProp(key, value) {
      var _this2 = this;
      var validator = this.validationMap.getValidatorForProperty(key);
      if (validator) {
        var normalizedValue = validator.normalizeNativeValue(value);
        if (normalizedValue instanceof _ShortMergeRequest.ShortMergeRequest) {
          normalizedValue.forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
              innerKey = _ref2[0],
              innerValue = _ref2[1];
            _this2.fillProp(innerKey, innerValue);
          });
        } else {
          // assume longhand merge
          this.processedProps.withProperty(key, normalizedValue, validator);
        }
      } else if ((0, _helpers.lookupRecord)(extraStylesRegistry, key)) {
        this.processedProps.withProperty(key, value, {
          compatCategory: 'native',
          displayCategory: extraStylesRegistry[key],
          propagationCategory: 'retain'
        });
      } else if ((0, _helpers.lookupRecord)(nativeDirectionalStyleKeys, key)) {
        console.warn("Native style property \"".concat(key, "\" is a directional style property. These are not yet supported."));
      } else {
        console.warn("Native style property \"".concat(key, "\" is not supported and has been ignored."));
      }
    }
  }, {
    key: "fillProcessedProps",
    value: function fillProcessedProps() {
      var declaration = this.declaration;
      for (var _i = 0, _Object$keys = Object.keys(declaration); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        this.fillProp(key, this.declaration[key]);
      }
    }
  }]);
  return CSSNativeParseRun;
}(_CSSParseRun.CSSParseRun);
exports.CSSNativeParseRun = CSSNativeParseRun;